import { DASH_PLACEHOLDER } from "../../constants/dashPlaceholder";
import type { AlternateCarrierCodeOption } from "../../constants/zipCodeOptions";
import type { ZipCodeItem } from "../../hooks/react-query/backOffice/transitTimesAndServiceLevels/useZipCodesList";

// ─── Mock Options Data ────────────────────────────────────────────────────────

export const ALTERNATE_CARRIER_CODE_OPTIONS = [
  { value: "FRAN", label: "FRAN" },
  { value: "BGLF", label: "BGLF" },
  { value: "GLOT", label: "GLOT" },
  { value: "ALMA", label: "ALMA" },
  { value: "AOXN", label: "AOXN" },
  { value: "BTNB", label: "BTNB" },
  { value: "C433", label: "C433" },
  { value: "C440", label: "C440" },
  { value: "C443", label: "C443" },
  { value: "JKSI", label: "JKSI" },
  { value: "C287", label: "C287" },
  { value: "BATL", label: "BATL" },
  { value: "GONZ", label: "GONZ" },
  { value: "MMTR", label: "MMTR" },
  { value: "TLIN", label: "TLIN" },
  { value: "JATT", label: "JATT" },
  { value: "ATUR", label: "ATUR" },
  { value: "MUSA", label: "MUSA" },
] as const satisfies readonly AlternateCarrierCodeOption[];

// ─── Mock Zip Codes Data ──────────────────────────────────────────────────────

// Mock zip codes data for Playwright tests and MSW handlers
export const mockZipCodesByServiceCenter: Record<string, ZipCodeItem[]> = {
  "1": [
    {
      id: 1,
      zipCode: "30301",
      city: "Atlanta",
      state: "GA",
      otherServiceCenter: "ALBANY",
      alternativeVendor: DASH_PLACEHOLDER,
      dowService: [46, 47, 48, 49, 50], // Mon-Fri (Backend values)
      additionalDays: 1,
      effectiveDate: "2024-01-01",
      expiryDate: "2099-12-31",
      status: "Active",
      operation: "All",
    },
    {
      id: 2,
      zipCode: "30302",
      city: "Atlanta",
      state: "GA",
      otherServiceCenter: "ATLANTA",
      alternativeVendor: "FRAN",
      dowService: [46, 47, 48, 49, 50],
      additionalDays: 0,
      effectiveDate: "2024-01-01",
      expiryDate: "2099-12-31",
      status: "Active",
      operation: "All",
    },
    {
      id: 3,
      zipCode: "30303",
      city: "Atlanta",
      state: "GA",
      otherServiceCenter: "AUGUSTA",
      alternativeVendor: DASH_PLACEHOLDER,
      dowService: [46, 47, 48, 49, 50],
      additionalDays: 0,
      effectiveDate: "2024-02-01",
      expiryDate: "2099-12-31",
      status: "Active",
      operation: "Delivery",
    },
    {
      id: 4,
      zipCode: "30304",
      city: "Atlanta",
      state: "GA",
      otherServiceCenter: "AUGUSTA",
      alternativeVendor: "BTNB",
      dowService: [46, 47, 48, 49, 50],
      additionalDays: 1,
      effectiveDate: "2024-03-01",
      expiryDate: "2099-12-31",
      status: "Active",
      operation: "Pickup",
    },
    {
      id: 5,
      zipCode: "30305",
      city: "Atlanta",
      state: "GA",
      otherServiceCenter: "ATLANTA",
      alternativeVendor: "AOXN",
      dowService: [46, 47, 48, 49, 50],
      additionalDays: 0,
      effectiveDate: "2024-01-01",
      expiryDate: "2099-12-31",
      status: "Active",
      operation: "All",
    },
    {
      id: 6,
      zipCode: "30306",
      city: "Atlanta",
      state: "GA",
      otherServiceCenter: "AUGUSTA",
      alternativeVendor: "GONZ",
      dowService: [46, 47, 48, 49, 50],
      additionalDays: 0,
      effectiveDate: "2023-01-01",
      expiryDate: "2024-12-31",
      status: "Inactive",
      operation: "Delivery",
    },
  ],
  "2": [
    {
      id: 7,
      zipCode: "75201",
      city: "Dallas",
      state: "TX",
      otherServiceCenter: "ALBANY",
      alternativeVendor: "TLIN",
      dowService: [46, 47, 48, 49, 50],
      additionalDays: 1,
      effectiveDate: "2024-01-01",
      expiryDate: "2099-12-31",
      status: "Active",
      operation: "All",
    },
  ],
};

export const mockEolZipCodesList: ZipCodeItem[] = [
  {
    id: 1,
    zipCode: "30301",
    city: "Atlanta",
    state: "GA",
    otherServiceCenter: "Vendor A",
    alternativeVendor: DASH_PLACEHOLDER,
    dowService: [46, 47, 48, 49, 50],
    additionalDays: 1,
    effectiveDate: "2024-01-01",
    expiryDate: "2099-12-31",
    status: "Active",
    operation: "All",
  },
  {
    id: 2,
    zipCode: "30302",
    city: "Atlanta",
    state: "GA",
    otherServiceCenter: "Vendor A",
    alternativeVendor: "FEDX",
    dowService: [46, 47, 48, 49, 50],
    additionalDays: 0,
    effectiveDate: "2024-01-01",
    expiryDate: "2099-12-31",
    status: "Active",
    operation: "All",
  },
  {
    id: 3,
    zipCode: "30303",
    city: "Atlanta",
    state: "GA",
    otherServiceCenter: "Vendor B",
    alternativeVendor: DASH_PLACEHOLDER,
    dowService: [46, 47, 48, 49, 50],
    additionalDays: 0,
    effectiveDate: "2024-02-01",
    expiryDate: "2099-12-31",
    status: "Active",
    operation: "Delivery",
  },
  {
    id: 4,
    zipCode: "30304",
    city: "Atlanta",
    state: "GA",
    otherServiceCenter: "Vendor A",
    alternativeVendor: "SAIA",
    dowService: [46, 47, 48, 49, 50],
    additionalDays: 1,
    effectiveDate: "2024-03-01",
    expiryDate: "2099-12-31",
    status: "Active",
    operation: "Pickup",
  },
  {
    id: 5,
    zipCode: "30305",
    city: "Atlanta",
    state: "GA",
    otherServiceCenter: "Vendor C",
    alternativeVendor: DASH_PLACEHOLDER,
    dowService: [46, 47, 48, 49, 50],
    additionalDays: 0,
    effectiveDate: "2024-01-01",
    expiryDate: "2099-12-31",
    status: "Active",
    operation: "All",
  },
  {
    id: 6,
    zipCode: "30306",
    city: "Atlanta",
    state: "GA",
    otherServiceCenter: "Vendor B",
    alternativeVendor: "UPSG",
    dowService: [46, 47, 48, 49, 50],
    additionalDays: 0,
    effectiveDate: "2023-01-01",
    expiryDate: "2024-12-31",
    status: "Inactive",
    operation: "Delivery",
  },
  {
    id: 7,
    zipCode: "75201",
    city: "Dallas",
    state: "TX",
    otherServiceCenter: "Vendor A",
    alternativeVendor: DASH_PLACEHOLDER,
    dowService: [46, 47, 48, 49, 50],
    additionalDays: 1,
    effectiveDate: "2024-01-01",
    expiryDate: "2099-12-31",
    status: "Active",
    operation: "All",
  },
];

export type EolServiceCenterDetails = {
  id: string;
  scCode: string;
  serviceCenterName: string;
  operationType: string;
  vendorScac: string;
  status: "Active" | "Inactive";
  lhJunction: boolean;
  operationalStatus: string;
  operationalStartDate: string;
  operationalEndDate: string;
  physicalAddress: string;
  country: string;
  scEffectiveDate: string;
  scExpiryDate: string;
  linehaulJunction: string;
  addressEffectiveDate: string;
  addressExpiryDate: string;
  latitude: string;
  longitude: string;
  timezone: string;
  addressStreet?: string;
  addressSuite?: string;
  addressCity?: string;
  addressState?: string;
  addressZip?: string;
};

/** EOL Service Center row for list/grid (UI format) */
type EolServiceCenterRowUI = {
  id: string;
  scCode: string;
  name: string;
  operationType: string;
  vendorScac: string;
  status: "Active" | "Inactive";
  lhJunction: boolean;
  latitude?: number;
  longitude?: number;
  timezone?: string;
};

/** EOL Service Centers for list page (matches detail IDs) */
export const mockEolServiceCenters: EolServiceCenterRowUI[] = [
  {
    id: "1",
    scCode: "ATL",
    name: "Atlanta EOL",
    operationType: "DYLT-operated",
    vendorScac: DASH_PLACEHOLDER,
    status: "Active",
    lhJunction: true,
  },
  {
    id: "2",
    scCode: "DFW",
    name: "Dallas EOL",
    operationType: "DYLT-operated",
    vendorScac: DASH_PLACEHOLDER,
    status: "Active",
    lhJunction: true,
  },
  {
    id: "3",
    scCode: "ORD",
    name: "Chicago EOL",
    operationType: "DYLT-operated",
    vendorScac: DASH_PLACEHOLDER,
    status: "Inactive",
    lhJunction: false,
  },
  {
    id: "4",
    scCode: "LAX",
    name: "Los Angeles EOL",
    operationType: "Vendor-operated",
    vendorScac: "VDSC",
    status: "Inactive",
    lhJunction: false,
  },
  {
    id: "5",
    scCode: "EWR",
    name: "Newark EOL",
    operationType: "DYLT-operated",
    vendorScac: DASH_PLACEHOLDER,
    status: "Active",
    lhJunction: true,
  },
];

/** Full EOL Service Center details (for details panel) */
export const mockEolServiceCenterDetails: EolServiceCenterDetails[] = [
  {
    id: "1",
    scCode: "ATL",
    serviceCenterName: "WEST ATLANTA",
    operationType: "DYLT-operated",
    vendorScac: "SFTL",
    status: "Active",
    lhJunction: true,
    operationalStatus: "Operational — No issues reported",
    operationalStartDate: "01/05/2026",
    operationalEndDate: "",
    physicalAddress: "735 MARIETTA, WEST ATLANTA, GA 30318",
    country: "US",
    scEffectiveDate: "01/05/2026",
    scExpiryDate: "",
    linehaulJunction: "Yes",
    addressEffectiveDate: "01/05/2026",
    addressExpiryDate: "",
    latitude: "33.749",
    longitude: "-84.388",
    timezone: "America/New_York",
  },
  {
    id: "2",
    scCode: "DFW",
    serviceCenterName: "DALLAS EOL",
    operationType: "DYLT-operated",
    vendorScac: DASH_PLACEHOLDER,
    status: "Active",
    lhJunction: true,
    operationalStatus: "Operational — No issues reported",
    operationalStartDate: "01/01/2025",
    operationalEndDate: "",
    physicalAddress: "1234 Commerce St, Dallas, TX 75201",
    country: "US",
    scEffectiveDate: "01/01/2025",
    scExpiryDate: "",
    linehaulJunction: "Yes",
    addressEffectiveDate: "01/01/2025",
    addressExpiryDate: "",
    latitude: "32.7767",
    longitude: "-96.797",
    timezone: "America/Chicago",
  },
  {
    id: "3",
    scCode: "ORD",
    serviceCenterName: "CHICAGO EOL",
    operationType: "DYLT-operated",
    vendorScac: DASH_PLACEHOLDER,
    status: "Inactive",
    lhJunction: false,
    operationalStatus: "Inactive",
    operationalStartDate: "06/15/2024",
    operationalEndDate: "12/31/2025",
    physicalAddress: "5678 Industrial Pkwy, Chicago, IL 60601",
    country: "US",
    scEffectiveDate: "06/15/2024",
    scExpiryDate: "12/31/2025",
    linehaulJunction: "No",
    addressEffectiveDate: "06/15/2024",
    addressExpiryDate: "12/31/2025",
    latitude: "41.8781",
    longitude: "-87.6298",
    timezone: "America/Chicago",
  },
  {
    id: "4",
    scCode: "LAX",
    serviceCenterName: "LOS ANGELES EOL",
    operationType: "Vendor-operated",
    vendorScac: "VDSC",
    status: "Inactive",
    lhJunction: false,
    operationalStatus: "Inactive",
    operationalStartDate: "03/10/2024",
    operationalEndDate: "10/15/2025",
    physicalAddress: "9876 Harbor Blvd, Los Angeles, CA 90001",
    country: "US",
    scEffectiveDate: "03/10/2024",
    scExpiryDate: "10/15/2025",
    linehaulJunction: "No",
    addressEffectiveDate: "03/10/2024",
    addressExpiryDate: "10/15/2025",
    latitude: "34.0522",
    longitude: "-118.2437",
    timezone: "America/Los_Angeles",
  },
  {
    id: "5",
    scCode: "EWR",
    serviceCenterName: "NEWARK EOL",
    operationType: "DYLT-operated",
    vendorScac: DASH_PLACEHOLDER,
    status: "Active",
    lhJunction: true,
    operationalStatus: "Operational — No issues reported",
    operationalStartDate: "02/01/2025",
    operationalEndDate: "",
    physicalAddress: "456 Newark Ave, Newark, NJ 07102",
    country: "US",
    scEffectiveDate: "02/01/2025",
    scExpiryDate: "",
    linehaulJunction: "Yes",
    addressEffectiveDate: "02/01/2025",
    addressExpiryDate: "",
    latitude: "40.7357",
    longitude: "-74.1724",
    timezone: "America/New_York",
  },
];

/** --- Add Service Center dialog (mock form options, addresses, duplicate rules) --- */

type CountryOption = {
  name: string;
  displayName: string;
  code: string;
};

export const mockAddServiceCenterCountries: readonly CountryOption[] = [
  { name: "United States of America (USA)", displayName: "USA", code: "US" },
  { name: "Canada (CAN)", displayName: "CAN", code: "CA" },
  { name: "Mexico (MEX)", displayName: "MEX", code: "MX" },
] as const;

export type AddServiceCenterCountry = {
  name: string;
  displayName: string;
  code: string;
};

export const mockAddServiceCenterOperationTypes = [
  "DYLT-operated",
  "Vendor-operated",
] as const;

export type AddServiceCenterOperationType =
  (typeof mockAddServiceCenterOperationTypes)[number];

/**
 * Codes treated as “already taken” in Add Service Center (in addition to list SC codes).
 * Note: do not add the SC code used in the save-path acceptance criteria to this list;
 * duplicate checks use the live grid plus these reserved codes (e.g. DCHI/DATL).
 */
export const mockExistingScCodesForDuplicateCheck = ["DCHI", "DATL"] as const;

export type VendorScacOption = {
  carrierName: string;
  code: string;
  vendorScac: string;
};

export const mockVendorScacOptions: readonly VendorScacOption[] = [
  {
    carrierName: "SOUTHEASTERN FREIGHT LINES",
    code: "C144",
    vendorScac: "SEFL",
  },
  { carrierName: "FRANCISCO INIQUEZ", code: "LAX263", vendorScac: "FRAN" },
] as const;

export type MockPhysicalAddress = {
  id: string;
  /** Full line shown in autocomplete and Physical Address field after select */
  fullAddress: string;
  street: string;
  suite: string;
  city: string;
  state: string;
  zip: string;
  latitude: number;
  longitude: number;
  timezone: string;
};

export const mockPhysicalAddresses: readonly MockPhysicalAddress[] = [
  {
    id: "addr-1",
    fullAddress: "1234 Commerce St, Dallas, TX 75201",
    street: "1234 Commerce St",
    suite: "",
    city: "Dallas",
    state: "TX",
    zip: "75201",
    latitude: 32.7767,
    longitude: -96.797,
    timezone: "America/Chicago",
  },
  {
    id: "addr-2",
    fullAddress: "231 Elm Street, Apt 12, Seattle, WA 98101",
    street: "231 Elm Street",
    suite: "Apt 12",
    city: "Seattle",
    state: "WA",
    zip: "98101",
    latitude: 47.6062,
    longitude: -122.3321,
    timezone: "America/Los_Angeles",
  },
  {
    id: "addr-3",
    fullAddress: "213 Oak Avenue, Suite 300, Denver, CO 80202",
    street: "213 Oak Avenue",
    suite: "Suite 300",
    city: "Denver",
    state: "CO",
    zip: "80202",
    latitude: 39.7392,
    longitude: -104.9903,
    timezone: "America/Denver",
  },
  {
    id: "addr-4",
    fullAddress: "321 Maple Drive, Floor 1, Miami, FL 33101",
    street: "321 Maple Drive",
    suite: "Floor 1",
    city: "Miami",
    state: "FL",
    zip: "33101",
    latitude: 25.7617,
    longitude: -80.1918,
    timezone: "America/New_York",
  },
  {
    id: "addr-5",
    fullAddress: "500 Market St, Suite 100, San Francisco, CA 94105",
    street: "500 Market St",
    suite: "Suite 100",
    city: "San Francisco",
    state: "CA",
    zip: "94105",
    latitude: 37.7749,
    longitude: -122.4194,
    timezone: "America/Los_Angeles",
  },
  {
    id: "addr-6",
    fullAddress: "88 Peachtree St NE, Floor 12, Atlanta, GA 30303",
    street: "88 Peachtree St NE",
    suite: "Floor 12",
    city: "Atlanta",
    state: "GA",
    zip: "30303",
    latitude: 33.749,
    longitude: -84.388,
    timezone: "America/New_York",
  },
  {
    id: "addr-7",
    fullAddress: "1 Main St, Unit 5, Boston, MA 02109",
    street: "1 Main St",
    suite: "Unit 5",
    city: "Boston",
    state: "MA",
    zip: "02109",
    latitude: 42.3601,
    longitude: -71.0589,
    timezone: "America/New_York",
  },
  {
    id: "addr-8",
    fullAddress: "2000 W Loop S, Ste 400, Houston, TX 77027",
    street: "2000 W Loop S",
    suite: "Ste 400",
    city: "Houston",
    state: "TX",
    zip: "77027",
    latitude: 29.7604,
    longitude: -95.3698,
    timezone: "America/Chicago",
  },
];

export function filterMockPhysicalAddresses(
  query: string
): MockPhysicalAddress[] {
  const q = query.trim().toLowerCase();
  // Only show suggestions after 3 characters
  if (q.length < 3) {
    return [];
  }
  return mockPhysicalAddresses.filter((a) => {
    const hay = [a.fullAddress, a.street, a.suite, a.city, a.state, a.zip]
      .join(" ")
      .toLowerCase();
    return hay.includes(q);
  });
}

// ─── Linehaul Transit Matrix list (UI) ───────────────────────────────────────
/** Raw fixture; validated at runtime in `useLinehaulTransitMatrixList`. */

export const mockLinehaulTransitMatrixList = [
  {
    id: "1",
    matrix: "Mon-LTL",
    serviceLevel: "LTL",
    dayOfWeek: "Monday",
    effectiveDate: "Jan 1, 2026",
    expiryDate: "Dec 31, 2026",
    lastUpdatedDate: "Mar 10, 2026",
    lastUpdatedBy: "J. Moreau",
    status: "ACTIVE",
  },
  {
    id: "2",
    matrix: "Tue-LTL",
    serviceLevel: "LTL",
    dayOfWeek: "Tuesday",
    effectiveDate: "Jan 1, 2026",
    expiryDate: "Dec 31, 2026",
    lastUpdatedDate: "Mar 19, 2026",
    lastUpdatedBy: "R. Singh",
    status: "ACTIVE",
  },
  {
    id: "3",
    matrix: "Wed-LTL",
    serviceLevel: "LTL",
    dayOfWeek: "Wednesday",
    effectiveDate: "Jan 1, 2026",
    expiryDate: "Dec 31, 2026",
    lastUpdatedDate: "Mar 15, 2026",
    lastUpdatedBy: "M. Chen",
    status: "ACTIVE",
  },
  {
    id: "4",
    matrix: "Thu-LTL",
    serviceLevel: "LTL",
    dayOfWeek: "Thursday",
    effectiveDate: "Jan 1, 2026",
    expiryDate: "Dec 31, 2026",
    lastUpdatedDate: "Mar 18, 2026",
    lastUpdatedBy: "T. Nguyen",
    status: "ACTIVE",
  },
  {
    id: "5",
    matrix: "Fri-LLL",
    serviceLevel: "LLL",
    dayOfWeek: "Friday",
    effectiveDate: "Jan 1, 2026",
    expiryDate: "Dec 31, 2026",
    lastUpdatedDate: "Mar 20, 2026",
    lastUpdatedBy: "S. Smith",
    status: "ACTIVE",
  },
];
